import { globalEntitlements } from '../utils/globalEntitlements';

export const BASIC_EMAIL_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.basicEmail.buyBox.bulletPoint1' },
        { title: 'productPage.basicEmail.buyBox.bulletPoint2' },
        { title: 'productPage.basicEmail.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.basicEmail.buyBox.productName',
      interactService: {
        service: 'basic_email'
      }
    }],
    headerPicture: {
      src: '/s2/raster/smiling-holding-phone-kitchen.png',
      alt: 'productPage.basicEmail.heroPicture.altText'
    },
    headline: 'productPage.basicEmail.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.basicEmail.page.subheader'
  },
  benefit: {
    title: 'productPage.basicEmail.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/folderopenrounded.svg',
        title: 'productPage.basicEmail.valueProp.propTitle1',
        description: 'productPage.basicEmail.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/bookrounded.svg',
        title: 'productPage.basicEmail.valueProp.propTitle2',
        description: 'productPage.basicEmail.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/eventnoterounded.svg',
        title: 'productPage.basicEmail.valueProp.propTitle3',
        description: 'productPage.basicEmail.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/inboxrounded.svg',
    title: 'productPage.basicEmail.topFeature.title',
    subheader: 'productPage.basicEmail.topFeature.subheader',
    image: '/s2/raster/apron-tablet-window.png',
    alt: 'productPage.basicEmail.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.basicEmail.howItWorks.title',
    items: [
      {
        title: 'productPage.basicEmail.howItWorks.step1',
        description: 'productPage.basicEmail.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.basicEmail.howItWorks.step2',
        description: 'productPage.basicEmail.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.basicEmail.howItWorks.step3',
        description: 'productPage.basicEmail.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/phone-desk-office.png',
    alt: 'productPage.basicEmail.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.basicEmail.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.basicEmail.frequentlyAskedQuestions.faq1',
        answer: 'productPage.basicEmail.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.basicEmail.frequentlyAskedQuestions.faq2',
        answer: 'productPage.basicEmail.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.basicEmail.frequentlyAskedQuestions.faq3',
        answer: 'productPage.basicEmail.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.basicEmail.frequentlyAskedQuestions.faq4',
        answer: 'productPage.basicEmail.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.basicEmail.needAssistance.title',
    getInTouch: 'productPage.basicEmail.needAssistance.getInTouch',
    actions: 'productPage.basicEmail.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.basicEmail.buyBox.buttonLabel'
  }).requiresProduct('domain_name_reg', 'productPage.basicEmail.buyBox.buttonDisabledNotAvailable.tooltip')
    .allowMultiplePurchases()
    .build()
};
